import { Command } from '@/app/common/base/command'

export class SaveFilledDocumentCommand extends Command {
    public async run(productActionId: string, filledPdfBase64: string, fieldValues: Record<string, string | boolean>): Promise<void> {
        await this.client.post(`/api/actions/${productActionId}/save-filled-document`, {
            filled_pdf: filledPdfBase64,
            field_values: fieldValues
        })
    }
}
